import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AccordionModule, ConfirmDialogModule, DataTableModule, EditorModule,
    FileUploadModule, TreeTableModule,TreeNode, TooltipModule} from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';

import { ProcessComponent } from './process.component';
import { ProcessDetailsComponent } from './processdetails/process-details.component';
import { ProcessUploadComponent } from './processupload/process-upload.component';
import { TaskListComponent } from './tasklist/task-list.component';
import { TaskEditorComponent } from './taskeditor/task-editor.component';

@NgModule({
    declarations: [ProcessComponent, TaskListComponent, ProcessDetailsComponent, TaskEditorComponent, ProcessUploadComponent],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
        ConfirmDialogModule,
        SharedModule,
        AccordionModule,
        FileUploadModule,
        EditorModule,
        TreeTableModule,
        TooltipModule
    ],
    providers: [],
    entryComponents: [
        ProcessComponent,
        TaskListComponent,
        ProcessDetailsComponent,
        TaskEditorComponent,
        ProcessUploadComponent
    ]
})

/**
 * Main module for process management.
*/
export class ProcessModule { }



// WEBPACK FOOTER //
// ./src/app/admin/processes/process.module.ts